export default __webpack_public_path__ + "static/media/check.908ab84d.svg";